module.exports = __webpack_public_path__ + "static/img/delete.c3ad6024.svg";